module.exports = __webpack_public_path__ + "static/media/yahuuu_congrats.c5ff9d7c.mp3";